import React from "react";
import { Pressable, Text, View } from "react-native";
import { useRsvpColors } from "../theme";

interface Props {
  quantity: number;
  onChange: (quantity: number) => void;
  maxQuantity: number | null; // null means no cap
}

const StepperButton: React.FC<{
  label: string;
  onPress: () => void;
  disabled?: boolean;
}> = ({ label, onPress, disabled }) => {
  const colors = useRsvpColors();
  return (
    <Pressable
      accessibilityRole="button"
      onPress={onPress}
      disabled={disabled}
      style={{
        width: 44,
        height: 44,
        borderRadius: 12,
        borderWidth: 1,
        borderColor: colors.inputBorder,
        backgroundColor: colors.inputBg,
        alignItems: "center",
        justifyContent: "center",
        opacity: disabled ? 0.4 : 1,
      }}
    >
      <Text
        style={{ color: colors.textPrimary, fontSize: 22, fontWeight: "600" }}
      >
        {label}
      </Text>
    </Pressable>
  );
};

const RsvpQuantityStepper: React.FC<Props> = ({
  quantity,
  onChange,
  maxQuantity,
}) => {
  const colors = useRsvpColors();
  const cap =
    maxQuantity == null ? Number.MAX_SAFE_INTEGER : Math.max(1, maxQuantity);

  return (
    <View style={{ alignItems: "center" }}>
      <View
        style={{
          flexDirection: "row",
          alignItems: "center",
          gap: 20,
        }}
      >
        <StepperButton
          label="−"
          onPress={() => onChange(Math.max(1, quantity - 1))}
          disabled={quantity <= 1}
        />
        <Text
          style={{
            color: colors.textPrimary,
            fontSize: 24,
            fontWeight: "700",
            minWidth: 32,
            textAlign: "center",
          }}
          accessibilityLabel={`Quantity ${quantity}`}
        >
          {quantity}
        </Text>
        <StepperButton
          label="+"
          onPress={() => onChange(Math.min(cap, quantity + 1))}
          disabled={quantity >= cap}
        />
      </View>
      {maxQuantity != null ? (
        <Text
          style={{
            color: colors.textFaint,
            fontSize: 12,
            marginTop: 8,
          }}
        >
          Maximum {cap} {cap === 1 ? "seat" : "seats"}
        </Text>
      ) : null}
    </View>
  );
};

export default RsvpQuantityStepper;
